export class Device {
    _id:string;
    userName: string;
    firstName: string;
    project: '';
    }